"use client";

import styles from "./Accordion.module.scss";

const Accordion = ({ title, children, isOpen, onToggle }) => {
  return (
    <div className={styles.accordion}>
      <button className={styles.accordionHeader} onClick={onToggle}>
        <span>{title}</span>
        <span className={styles.icon}>{isOpen ? "−" : "+"}</span>
      </button>
      {isOpen && <div className={styles.accordionContent}>{children}</div>}
    </div>
  );
};

export default Accordion;
